export default "__VITE_ASSET__JcJu2ww5la6KY1VF5rHq_w__"